const RestaurantButton = ({ onClick }) => (
  <button className="btn btn-primary" onClick={onClick}>
    Add
  </button>
);

export default RestaurantButton;
